import axios from 'axios'
import {API_URL} from '../constants';

const SHOPS_API_URL = `${API_URL}/shops`;

class ShopDataService {

    retrieveShops() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveCachedShops() {
        let s = localStorage.getItem("shops");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }

        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("shops", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            localStorage.setItem("shops", '[]');
            return error;
        });
    }

    retrieveById(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findById/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveByName(name) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findByName/${name}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveShopsByItem(itemId){
        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findShopsByItem/${itemId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveUnassignedShopsByItem(itemId){
        const token = sessionStorage.getItem('token');
        return axios.get(`${SHOPS_API_URL}/findUnassignedShopsByItem/${itemId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    save(shop) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${SHOPS_API_URL}/save`, shop,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    update(shop) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${SHOPS_API_URL}/update`, shop,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${SHOPS_API_URL}/deleteById/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveShopItem(shopItem) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${SHOPS_API_URL}/saveShopItem`, shopItem,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteShopItem(shopItem) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${SHOPS_API_URL}/deleteShopItem`, shopItem,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new ShopDataService()